import { render, staticRenderFns } from "./SponsorModal.vue?vue&type=template&id=0746e8cd"
import script from "./SponsorModal.vue?vue&type=script&lang=js"
export * from "./SponsorModal.vue?vue&type=script&lang=js"
import style0 from "./SponsorModal.vue?vue&type=style&index=0&id=0746e8cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports